module.exports = __webpack_public_path__ + "@/assets/img/015-boy-6.b5a5f5cf.svg";